$(document).ready(function () {
    var ca_page = 1;
    var ca_lock = false;
    $('.js-load_more').on("click", function () {
        if ((ca_page + 1) <= page_info.total_pages && !ca_lock) {
            ca_lock = true;
            var ca_param = "page=" + (ca_page + 1);
            if (page_info.page_tag !== null) {
                ca_param += "&tag=" + page_info.page_tag;
            }
            $(".loading_question").removeClass("hidden");
            var current_element = $(this);
            current_element.addClass("hidden");
            $.ajax(
                {
                    url: '/api/counseloranswer/',
                    data: ca_param,
                    type: "GET",
                    success: function (data) {
                        if (data.status == "success") {
                            ca_page++;
                            var counselor_question_block = data.counselor_answer_html;
                            $('.counselor_questions').append(counselor_question_block);
                        }
                    }
                }
            ).always(function () {
                $(".loading_question").addClass("hidden");
                ca_lock = false;
                current_element.removeClass("hidden");
                if (ca_page >= page_info.total_pages) {
                    current_element.hide();
                }
            });
        }
    });

    //handle show more in counselor answer page
    $(".counselor_question_item .js-show_more a").on("click", function () {
        var $this = $(this);
        var $content = $this.parent().parent();
        var linkText = $this.text().toUpperCase();
        $content.toggleClass("truncate_content");
        $this.parent().toggleClass("show_more--static");
        if (linkText === "SHOW MORE") {
            linkText = "Show less";
        } else {
            linkText = "Show more";
        };
        $this.text(linkText);
        $this.blur();

    });
})
